import React from "react";
import { StoryCard } from "./StoryCard";
import styles from "./Stories.module.scss";

const storyCards = [
  {
    title: "Diverse",
    highlightedText: "Visual",
    afterHighlightedText: "Stories",
    description:
      "Explore a variety of genres, from romance and mystery to adventure and fantasy. There’s something for everyone!",
    style: { width: "492px" }
  },
  {
    title: "Interactive",
    highlightedText: "Choices",
    description:
      " Your decisions shape the story, leading to unique endings and unforgettable moments.",
      style: { width: "320px" }
    },
  {
    title: "Immersive",
    highlightedText: "Experience",
    description:
      " Stunning visuals and engaging narratives bring stories to life like never before.",
    style: { width: "220px" },
    backgroundColor: "rgba(154, 55, 241, 0.8)"
  }
];

export const Stories = () => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.heading}>What sets us apart...</h2>
        <div className={styles.cardsContainer}>
          <div className={styles.cardsWrapper}>
            <div className={styles.cardsGrid}>
              {storyCards.map((card, index) => (
                <StoryCard
                  key={index}
                  title={card.title}
                  highlightedText={card.highlightedText}
                  afterHighlightedText={card.afterHighlightedText}
                  description={card.description}
                  style={card.style}
                  backgroundColor={card.backgroundColor}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
